import React from 'react';
import { useAuth } from '../hooks/useAuth';
import CreateOrganisation from '../screens/CreateOrganisation/CreateOrganisation';

const RequireOrg: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isInitializing } = useAuth();

  if (isInitializing) {
    return null;
  }

  if (!user?.organizationId) {
    return <CreateOrganisation />;
  }

  return <>{children}</>;
};

export default RequireOrg;
